/**
 * CurrentContext Component
 *
 * Displays the current organization context with name, URL, and status badge.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FiMonitor } from 'react-icons/fi';

const CurrentContext = ({ currentOrgId, currentOrg }) => {
    return (
        <div className="dos-current-context">
            <div className="dos-context-header">
                <FiMonitor className="dos-context-icon" />
                <span className="dos-context-title">Current Context</span>
            </div>
            <div className="dos-context-info">
                <div className="dos-context-name">
                    {currentOrgId === 'main-prod-db' ? 'Main Production Database' :
                     currentOrg ? currentOrg.name : 'Local Development Database'}
                </div>
                <div className="dos-context-url">
                    {currentOrgId === 'main-prod-db' ? 'clockwisecpa.app' :
                     currentOrg && !currentOrg.isLocalDev ? `${currentOrg.subdomain}.clockwisecpa.app` :
                     'localhost:3000'}
                </div>
                <div className={`dos-context-status ${
                    currentOrgId === 'main-prod-db' ? 'dos-prod-env' :
                    currentOrg && !currentOrg.isLocalDev ? 'dos-org-context' : 'dos-local-dev'
                }`}>
                    {currentOrgId === 'main-prod-db' ? 'Production Environment' :
                     currentOrg && !currentOrg.isLocalDev ? 'Organization Context' :
                     'Local Development'}
                </div>
            </div>
        </div>
    );
};

CurrentContext.propTypes = {
    currentOrgId: PropTypes.string,
    currentOrg: PropTypes.shape({
        organization_id: PropTypes.string,
        name: PropTypes.string,
        subdomain: PropTypes.string,
        status: PropTypes.string,
        isLocalDev: PropTypes.bool
    })
};

export default CurrentContext;
